import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  dot: {
    fontSize: 10,
    margin: theme.spacing(2, 0),
    marginRight: theme.spacing(0.5),
  },
}));

export default useStyles;
